module.exports = __webpack_public_path__ + "static/media/complot.cb4cccdf.jpg";